module.exports = __webpack_public_path__ + "static/media/Blue-checkmark-ready-to-process.2c6234ee.png";